import React, { Component, ReactElement } from "react";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil } from "@eres/core";
import { $ } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";

export interface Props {
	title: string | LocaleValue;
	id: string;
	onDone?: () => boolean;
	onReset?: () => void;
	wrapperClass?: string;
	dropWrapperClass?: string;
	extraWrapperDiv?: string;
	dropButtonClass?: string;
	dontWrap?: boolean;
	info?: ReactElement;
}

class BaseDropDown extends Component<Props> {
	static defaultProps: Partial<Props> = {
		wrapperClass: "col-lg-2 col-md-4 col-sm-6 col-xs-12",
		dropWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
		dropButtonClass: "btn btn-default m-0",
	};

	componentDidMount() {
		// work around for drop down disappear on click
		$( document ).on( "click.bs.dropdown.data-api", ".dropdown.keep-inside-clicks-open", function ( e: any ) {
			e.stopPropagation();
		} );
	}

	render() {
		const {
			id, title, onDone, onReset, extraWrapperDiv, dontWrap,
			wrapperClass, dropWrapperClass, dropButtonClass, info,
		} = this.props;
		const xView = <>{ this.props.children }
			<div className="dropdown-footer">
				<button
					type="button" className="btn btn-light btn-sm"
					onClick={ onReset }>{ Strings.reset }</button>
				<button
					type="submit" className="btn btn-success btn-sm"
					onClick={ this.onDone }>{ Strings.done }</button>
			</div>
		</>;
		const dropDown = dontWrap ?
			<div className="dropdown keep-inside-clicks-open">
				<button
					id={ id } className={ dropButtonClass } type="button"
					data-bs-toggle="dropdown"
					aria-haspopup="true" aria-expanded="false">
					{ LocaleUtil.getLocalValue( title ) }
				</button>
				{ info }
				<div className="dropdown-menu">
					{ xView }
				</div>
			</div>
			:
			<div className="dropdown keep-inside-clicks-open">
				<button
					id={ id } className={ dropButtonClass } type="button"
					data-bs-toggle="dropdown"
					aria-haspopup="true" aria-expanded="false">
					{ LocaleUtil.getLocalValue( title ) }
				</button>
				{ info }
				<div className="dropdown-menu">
					<div className="row">
						<div className={ dropWrapperClass }>
							{ xView }
						</div>
					</div>
				</div>
			</div>;
		if ( extraWrapperDiv ) {
			return (
				<div className={ wrapperClass }>
					<div className={ extraWrapperDiv }>
						{ dropDown }
					</div>
				</div>
			);
		}
		return (
			<div className={ wrapperClass }>
				{ dropDown }
			</div>
		);
	}

	onDone = () => {
		const handler = this.props.onDone;
		let hideMe = true;
		if ( handler ) {
			hideMe = handler();
		}
		if ( hideMe ) {
			$( "#" + this.props.id ).dropdown( "toggle" );
		}
	};
}

export default BaseDropDown;
